import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Comment } from '../../types/entity.types';
import { CreateCommentRequest, DeleteCommentRequest, ViewCommentsRequest } from './comment.types';

import { requestCreateComment, requestDeleteComment, requestViewComments } from './comment.actions';

export const useCommentApi = () => {
  const dispatch = useDispatch();

  const createComment = useCallback(
    (requestData: CreateCommentRequest, onSuccess?: (commentExternalReference?: string) => void) => {
      dispatch(requestCreateComment({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const viewComments = useCallback(
    (requestData: ViewCommentsRequest, onSuccess?: (comments: Comment[]) => void) => {
      dispatch(requestViewComments({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const deleteComment = useCallback(
    (requestData: DeleteCommentRequest, onSuccess?: () => void) => {
      dispatch(requestDeleteComment({ requestData, onSuccess }));
    },
    [dispatch]
  );

  return { createComment, viewComments, deleteComment };
};
